import { render, staticRenderFns } from "./DelegateCustomers.vue?vue&type=template&id=623ba3cd&scoped=true"
import script from "./DelegateCustomers.vue?vue&type=script&lang=js"
export * from "./DelegateCustomers.vue?vue&type=script&lang=js"
import style0 from "./DelegateCustomers.vue?vue&type=style&index=0&id=623ba3cd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "623ba3cd",
  null
  
)

export default component.exports